<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
  <div class="meet">
    <div class="local_player">
      <agora
        ref="ar"
        :channel="channel"
        :appid="appid"
        :token="token"
        :autoStart="true"
        :errorHandler="handleError"
        @user-joined="handleUserJoin"
        @user-published="handleUserPublished"
        @user-left="handleUserLeft"
        @join-success="handleJoinSuccess"
        @client-created="handleClientCreated"
        @stream-fallback="handleStreamFallback"
        enableDualStream
      >
        <!-- Audio Sender -->
        <agora-audio-sender
          ref="audioSender"
          :mute="mute"
          @track-created="handleAudioTrackCreated"
        />

        <!-- Audio Receiver -->
        <agora-audio-receiver
          ref="audioReceiver"
          :refuse="refuseList"
        />

        <!-- Local Video -->
        <agora-video-sender
          ref="videoSender"
          :cameraOff="cameraIsClosed"
          customizationPlayer
          @video-ready="handleVideoReady"
          @video-close="handleVideoClose"
        />

        <!-- Remote Video -->
        <agora-video-receiver
          customizationPlayer
          :refuse="refuseList"
          @video-ready="handleRemoteVideoReady"
        />
      </agora>

      <!-- Screen Sharing -->
      <agora
        v-if="openScreenSharing"
        ref="screenAr"
        :channel="channel"
        :appid="appid"
        :token="token"
        :uid="shareScreenUID"
      >
        <agora-video-sender
          customizationPlayer
          type="screen"
          @video-ready="handleScreenVideoReady"
          @video-close="handleScreenVideoClose"
          @video-create-failed="handleScreenVideoFailed"
        />
      </agora>
    </div>

    <!-- Players -->
    <div
      class="player"
      :class="{
        'screen-share-player':
          youAreShareScreening || otherIsShareScreening
      }"
    >
      <div
        v-for="user_id in userIdList"
        :key="user_id"
        class="user-vision"
        :class="{
          'screen-share-vision':
            user_id === shareScreenUID,

          'screen-share-vision-pined':
            user_id === shareScreenUID &&
            user_id === pinedUid
        }"
      >
        <div
          v-if="playList.find(e => e.uid === user_id)"
          v-player="playList.find(e => e.uid === user_id)"
          class="player-vision"
          v-show="!streamFallbackList.includes(user_id)"
        />

        <div class="ban">
          <pin-button
            v-if="pined && user_id === pinedUid"
            :couldHover="false"
          />

          <voice-dot
            :level="
              audioStatusObj[user_id || uid] &&
              audioStatusObj[user_id || uid].level
                ? audioStatusObj[user_id || uid].level
                : 0
            "
            :mute="
              audioStatusObj[user_id || uid]
                ? audioStatusObj[user_id || uid].mute
                : true
            "
          />

          <p>
            {{ user_id || "you" }}

            <span
              v-if="user_id === uid && inMeeting"
            >
              ( you )
            </span>
          </p>
        </div>

        <avatar-audio
          avatar="../assets/yonghu.svg"
          :level="
            audioStatusObj[user_id || uid] &&
            audioStatusObj[user_id || uid].level
              ? audioStatusObj[user_id || uid].level
              : 0
          "
          :mute="
            audioStatusObj[user_id || uid]
              ? audioStatusObj[user_id || uid].mute
              : true
          "
          :cameraOff="
            !playList.find(e => e.uid === user_id) ||
            streamFallbackList.includes(user_id)
          "
        />

        <div class="central">
          <pin-button
            class="pin-button-local"
            :pined="
              pined &&
              (
                user_id
                  ? pinedUid === user_id
                  : pinedUid === uid
              )
            "
            @click="handlePinUser(user_id || uid)"
          />
        </div>
      </div>
    </div>

    <!-- Local Preview -->
    <div class="notify">
      <div
        class="remote-user"
        @click="handleExpandUserList"
      >
        {{ $t("user") }}: {{ users.length }}
      </div>

      <div class="local-user">
        <div class="local-camera-player">
          <voice-dot
            class="voice-dot-local"
            :mute="mute"
            :level="localVolumeLevel"
          />

          <video
            v-show="!cameraIsClosed"
            autoplay
            muted
            playsinline
            ref="localCameraPlayer"
          />

          <img
            v-show="cameraIsClosed"
            src="../assets/yonghu.svg"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- Users List -->
    <div
      class="user-list"
      v-show="showExpandUserList"
    >
      <p @click="handleCustom">
        {{ $t("all_users_in_meeting") }}
      </p>

      <ul>
        <li
          v-for="(item, index) in users"
          :key="index"
        >
          <voice-dot
            class="audio-dot-local"
            :level="
              audioStatusObj[item.uid || uid] &&
              audioStatusObj[item.uid || uid].level
                ? audioStatusObj[item.uid || uid].level
                : 0
            "
            :mute="
              audioStatusObj[item.uid || uid]
                ? audioStatusObj[item.uid || uid].mute
                : true
            "
          />

          <pin-button
            class="pin-button-local"
            :pined="
              pined &&
              (
                item.uid
                  ? pinedUid === item.uid
                  : pinedUid === uid
              )
            "
            @click="
              handlePinUser(item.uid || uid)
            "
          />

          {{ item.uid || item }}
        </li>
      </ul>
    </div>

    <!-- Controls -->
    <div class="banner">
      <mp-button
        :class="microphoneClass"
        @click="handleMute"
      />

      <on-call-button
        v-if="!inMeeting"
        @click="handleCall"
      />

      <close-button
        v-if="inMeeting"
        @click="handleLeave"
      />

      <video-button
        :class="cameraClass"
        @click="handleCamera"
      />
    </div>
  </div>
</template>

<script>
import MpButton from "./buttons/mp-button";
import CloseButton from "./buttons/close-button";
import OnCallButton from "./buttons/on-call-button";
import VideoButton from "./buttons/video-button";
import VoiceDot from "./voice-dot/main";
import AvatarAudio from "./avatar-audio/main";
import PinButton from "./pin-button/main";

export default {
  name: "Meet",

  components: {
    MpButton,
    CloseButton,
    OnCallButton,
    VideoButton,
    VoiceDot,
    AvatarAudio,
    PinButton
  },

  props: {
    channel: {
      type: [String, null]
    },

    appid: {
      type: [String, null]
    },

    token: {
      type: [String, null]
    },

    userAccount: {
      type: [String, null]
    },

    preMute: {
      type: Boolean,
      default: false
    },

    preCameraOff: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mute: false,

      handleError: error => {
        console.error(
          "[Agora] ERROR:",
          error
        );
      },

      uid: null,

      cameraIsClosed: false,

      inMeeting: false,

      remoteUsers: [],

      showExpandUserList: false,

      localDirective: null,

      localScreenDirective: null,

      localVolumeLevel: 0,

      remoteVolumeLevelList: [],

      remoteDirectiveList: [],

      remoteMuteStatus: [],

      remoteCusrentUser: [],

      pined: true,

      pinedUid: null,

      openScreenSharing: false,

      youAreShareScreening: false,

      shareScreenUID: 99991234,

      streamFallbackList: [],

      localAudioAnimationId: null,

      remoteVolumeAnimationId: null,

      remoteMuteAnimationId: null,

      audioDiagnosticTimers: []
    };
  },

  computed: {
    refuseList() {
      return this.openScreenSharing
        ? [this.shareScreenUID]
        : [];
    },

    microphoneClass() {
      return this.mute
        ? "mp-mute"
        : "mp-normal";
    },

    cameraClass() {
      return this.cameraIsClosed
        ? "video-mute"
        : "video-normal";
    },

    users() {
      const result = [
        ...this.remoteUsers
      ];

      result.unshift(
        this.uid
          ? this.uid + `(${this.$t("you")})`
          : this.$t("you")
      );

      if (this.youAreShareScreening) {
        result.unshift(
          this.shareScreenUID
        );
      }

      return result;
    },

    userList() {
      const result = [
        ...this.remoteUsers
      ];

      this.remoteCusrentUser = result;

      if (this.uid) {
        result.unshift(this.uid);
      }

      if (this.youAreShareScreening) {
        result.unshift(
          this.shareScreenUID
        );
      }

      return result;
    },

    unpinedUserIdList() {
      const result =
        this.remoteUsers.map(
          user => user.uid
        );

      if (this.uid) {
        result.unshift(this.uid);
      }

      if (this.youAreShareScreening) {
        result.unshift(
          this.shareScreenUID
        );
      }

      return result;
    },

    userIdList() {
      if (this.pined) {
        return [this.pinedUid];
      }

      return this.unpinedUserIdList;
    },

    playList() {
      const result = [
        ...this.remoteDirectiveList
      ];

      if (this.localDirective) {
        result.unshift(
          this.localDirective
        );
      }

      if (this.localScreenDirective) {
        result.unshift(
          this.localScreenDirective
        );
      }

      return result;
    },

    /*
     * IMPORTANT:
     *
     * النسخة القديمة كانت:
     *
     * mute: muteStatus[k] !== false
     *
     * وبالتالي undefined كان يظهر كمصمت.
     */
    remoteAudioStatusObj() {
      const volumeLevel =
        Object.assign(
          {},
          ...this.remoteVolumeLevelList.map(
            e => ({
              [e.uid]: e.result
            })
          )
        );

      const muteStatus =
        Object.assign(
          {},
          ...this.remoteMuteStatus.map(
            e => ({
              [e.uid]: e.result
            })
          )
        );

      this.remoteCusrentUser = [
        ...this.remoteUsers
      ];

      return Object.assign(
        {},
        ...this.remoteUsers.map(
          user => ({
            [user.uid]: {
              level:
                volumeLevel[user.uid] || 0,

              data: user.uid,

              /*
               * Agora hasAudio هو المصدر
               * الأساسي لمعرفة هل المستخدم
               * ينشر Audio أم لا.
               */
              mute:
                user.hasAudio === false ||
                muteStatus[user.uid] === true
            }
          })
        )
      );
    },

    audioStatusObj() {
      const localStatus = {};

      if (this.uid !== null) {
        localStatus[this.uid] = {
          level:
            this.localVolumeLevel || 0,

          mute: this.mute
        };
      }

      return {
        ...localStatus,
        ...this.remoteAudioStatusObj
      };
    },

    otherIsShareScreening() {
      return (
        !this.youAreShareScreening &&
        this.unpinedUserIdList.includes(
          this.shareScreenUID
        )
      );
    }
  },

  watch: {
    cameraIsClosed(newV) {
      if (
        !newV &&
        this.$refs.videoSender &&
        this.$refs.localCameraPlayer
      ) {
        this.playLocalVideoOnTopBanner();
      }
    }
  },

  created() {
    this.mute = this.preMute;

    this.cameraIsClosed =
      this.preCameraOff;
  },

  beforeDestroy() {
    this.stopMonitoring();

    this.audioDiagnosticTimers.forEach(
      timer => clearTimeout(timer)
    );

    this.audioDiagnosticTimers = [];
  },

  methods: {
    handleOpenNewPage() {
      window.open(
        window.location.href
      );
    },

    handleCustom() {
      try {
        const tracks =
          this.$refs.ar.getLocalTracks();

        console.log(
          "[Agora] LOCAL TRACKS:",
          tracks
        );
      } catch (error) {
        console.error(
          "[Agora] getLocalTracks error:",
          error
        );
      }
    },

    /*
     * ===============================
     * JOIN SUCCESS
     * ===============================
     */

    async handleJoinSuccess(uid) {
      this.inMeeting = true;

      this.uid = uid;

      console.log(
        "[Agora] JOIN SUCCESS",
        {
          uid,
          channel: this.channel,
          preMute: this.preMute,
          currentMute: this.mute
        }
      );

      await this.$nextTick();

      this.refreshRemoteUsers();

      /*
       * نفحص الميكروفون بعد الدخول.
       *
       * أكثر من محاولة لأن الجوال
       * قد يتأخر في إنشاء الـ track.
       */
      this.scheduleAudioDiagnostics();

      this.$message.success(
        this.$t("join_succeed")
      );
    },

    /*
     * ===============================
     * CLIENT CREATED
     * ===============================
     */

    handleClientCreated() {
      window._agMeet = this;

      window._client =
        this.$refs.ar.getClient();

      window._AgoraRTC =
        this.$refs.ar.getAgoraRtc();

      window._sClient =
        this.$refs?.screenAr?.getClient();

      console.log(
        "[Agora] CLIENT CREATED"
      );
    },

    /*
     * ===============================
     * MUTE
     * ===============================
     */

    handleMute() {
      this.mute = !this.mute;

      console.log(
        "[Agora] LOCAL MUTE CHANGED",
        {
          mute: this.mute
        }
      );

      this.$message(
        `${this.$t("mike_mute")} ${
          this.mute
            ? "OFF"
            : "ON"
        }`
      );

      /*
       * بعد تغيير mute نعيد فحص
       * الـ Local Track.
       */
      this.$nextTick(() => {
        const timer = setTimeout(
          () => {
            this.checkLocalAudioState(
              "after-mute-change"
            );
          },
          300
        );

        this.audioDiagnosticTimers.push(
          timer
        );
      });
    },

    /*
     * ===============================
     * LOCAL VIDEO
     * ===============================
     */

    playLocalVideoOnTopBanner() {
      try {
        if (
          !this.$refs.videoSender ||
          !this.$refs.videoSender.getTrack()
        ) {
          return;
        }

        const videoTrack =
          this.$refs.videoSender
            .getTrack()
            .getMediaStreamTrack();

        this.$refs.localCameraPlayer.srcObject =
          new MediaStream([
            videoTrack
          ]);
      } catch (error) {
        console.error(
          "[Agora] LOCAL VIDEO ERROR:",
          error
        );
      }
    },

    /*
     * ===============================
     * CALL
     * ===============================
     */

    handleCall() {
      if (this.inMeeting) {
        this.$message.error(
          this.$t("you_is_ready")
        );

        return;
      }

      this.$refs.ar
        .start()
        .then(
          ({
            result,
            message
          }) => {
            if (!result) {
              console.error(
                "[Agora] JOIN FAILED:",
                message
              );
            }
          }
        )
        .catch(error => {
          console.error(
            "[Agora] START ERROR:",
            error
          );
        });
    },

    /*
     * ===============================
     * LEAVE
     * ===============================
     */

    handleLeave() {
      if (!this.inMeeting) {
        this.$message.error(
          this.$t(
            "you_not_ready"
          )
        );

        return;
      }

      this.stopMonitoring();

      this.$refs.ar
        .leave()
        .then(() => {
          this.inMeeting = false;

          this.remoteUsers = [];

          this.uid = null;

          this.$message.success(
            this.$t(
              "you_leave_meeting"
            )
          );

          this.$emit(
            "leave-meeting"
          );
        })
        .catch(error => {
          console.error(
            "[Agora] LEAVE ERROR:",
            error
          );
        });
    },

    /*
     * ===============================
     * CAMERA
     * ===============================
     */

    handleCamera() {
      this.cameraIsClosed =
        !this.cameraIsClosed;

      this.$message(
        `${this.$t(
          "camera_is_closed"
        )} ${
          this.cameraIsClosed
            ? "OFF"
            : "ON"
        }`
      );
    },

    /*
     * ===============================
     * REMOTE USER JOIN
     * ===============================
     */

    handleUserJoin(user) {
      console.log(
        "[Agora] USER JOINED",
        {
          uid: user.uid,
          hasAudio:
            user.hasAudio,
          hasVideo:
            user.hasVideo
        }
      );

      const client =
        this.$refs.ar.getClient();

      /*
       * فقط remote UID.
       *
       * لا نستخدم userAccount هنا.
       */
      try {
        client.setStreamFallbackOption(
          user.uid,
          2
        );
      } catch (error) {
        console.warn(
          "[Agora] STREAM FALLBACK ERROR:",
          error
        );
      }

      this.$message(
        `${user.uid} ${this.$t(
          "join_to_mmeet"
        )}`
      );

      this.handlePinUser(
        user.uid
      );

      this.cameraIsClosed =
        this.preCameraOff;

      this.refreshRemoteUsers();

      this.handleCheckRemoteUserAudioMuteStatus();

      /*
       * Debug:
       *
       * نتحقق بعد لحظة هل المستخدم
       * بدأ publish للصوت.
       */
      const timer = setTimeout(
        () => {
          const remote =
            client.remoteUsers.find(
              item =>
                item.uid ===
                user.uid
            );

          console.log(
            "[Agora] REMOTE STATE AFTER JOIN",
            {
              uid:
                remote?.uid,
              hasAudio:
                remote?.hasAudio,
              hasVideo:
                remote?.hasVideo,
              audioTrack:
                !!remote?.audioTrack
            }
          );
        },
        1500
      );

      this.audioDiagnosticTimers.push(
        timer
      );
    },

    /*
     * ===============================
     * REMOTE USER PUBLISHED
     * ===============================
     */

    async handleUserPublished(
      user,
      mediaType
    ) {
      console.log(
        "[Agora] USER PUBLISHED",
        {
          uid: user.uid,
          mediaType,
          hasAudio:
            user.hasAudio,
          hasVideo:
            user.hasVideo
        }
      );

      const client =
        this.$refs.ar.getClient();

      try {
        /*
         * Explicit subscribe.
         */
        await client.subscribe(
          user,
          mediaType
        );

        console.log(
          "[Agora] SUBSCRIBED",
          {
            uid: user.uid,
            mediaType,
            hasAudio:
              user.hasAudio,
            hasVideo:
              user.hasVideo,
            hasAudioTrack:
              !!user.audioTrack
          }
        );

        /*
         * AUDIO
         */
        if (
          mediaType ===
          "audio"
        ) {
          if (
            user.audioTrack
          ) {
            try {
              user.audioTrack.play();

              console.log(
                "[Agora] REMOTE AUDIO PLAY",
                user.uid
              );
            } catch (
              playError
            ) {
              console.error(
                "[Agora] AUDIO PLAY ERROR:",
                playError
              );
            }
          } else {
            console.warn(
              "[Agora] Audio published but audioTrack missing:",
              user.uid
            );
          }

          this.handleGetRemoteVolumeLevelList();
        }

        /*
         * VIDEO
         */
        if (
          mediaType ===
          "video"
        ) {
          this.handleRemoteVideoReady(
            this.$refs.ar.getRemoteUsers()
          );
        }

        this.refreshRemoteUsers();
      } catch (error) {
        console.error(
          "[Agora] SUBSCRIBE ERROR",
          {
            uid: user.uid,
            mediaType,
            error
          }
        );
      }
    },

    /*
     * ===============================
     * USER LEFT
     * ===============================
     */

    handleUserLeft(
      user,
      reason
    ) {
      console.log(
        "[Agora] USER LEFT",
        {
          uid: user.uid,
          reason
        }
      );

      this.refreshRemoteUsers();

      if (
        user.uid ===
        this.pinedUid
      ) {
        this.pined = false;

        this.pinedUid = null;
      }
    },

    /*
     * ===============================
     * REFRESH REMOTE USERS
     * ===============================
     */

    refreshRemoteUsers() {
      try {
        if (!this.$refs.ar) {
          return;
        }

        const users =
          this.$refs.ar.getRemoteUsers() ||
          [];

        this.remoteUsers =
          users.filter(
            user =>
              !this.openScreenSharing ||
              user.uid !==
                this.shareScreenUID
          );

        console.log(
          "[Agora] REMOTE USERS STATE",
          this.remoteUsers.map(
            user => ({
              uid:
                user.uid,

              hasAudio:
                user.hasAudio,

              hasVideo:
                user.hasVideo,

              audioTrack:
                !!user.audioTrack
            })
          )
        );
      } catch (error) {
        console.error(
          "[Agora] REFRESH REMOTE USERS ERROR:",
          error
        );
      }
    },

    /*
     * ===============================
     * LOCAL AUDIO DIAGNOSTIC
     * ===============================
     */

    checkLocalAudioState(
      source = "manual"
    ) {
      try {
        const audioSender =
          this.$refs.audioSender;

        if (!audioSender) {
          console.error(
            "[Agora] audioSender not found",
            source
          );

          return;
        }

        const track =
          audioSender.getTrack();

        if (!track) {
          console.error(
            "[Agora] LOCAL AUDIO TRACK MISSING",
            {
              source,
              uid: this.uid,
              mute:
                this.mute
            }
          );

          return;
        }

        let mediaStreamTrack =
          null;

        try {
          if (
            track.getMediaStreamTrack
          ) {
            mediaStreamTrack =
              track.getMediaStreamTrack();
          }
        } catch (error) {
          console.warn(
            "[Agora] getMediaStreamTrack failed",
            error
          );
        }

        let volume = null;

        try {
          if (
            track.getVolumeLevel
          ) {
            volume =
              track.getVolumeLevel();
          }
        } catch (error) {
          // ignore
        }

        console.log(
          "[Agora] LOCAL AUDIO STATE",
          {
            source,

            uid:
              this.uid,

            trackExists:
              !!track,

            muted:
              track.muted,

            enabled:
              track.enabled,

            volume,

            readyState:
              mediaStreamTrack
                ? mediaStreamTrack.readyState
                : null,

            mediaEnabled:
              mediaStreamTrack
                ? mediaStreamTrack.enabled
                : null,

            mediaMuted:
              mediaStreamTrack
                ? mediaStreamTrack.muted
                : null
          }
        );
      } catch (error) {
        console.error(
          "[Agora] CHECK LOCAL AUDIO ERROR:",
          error
        );
      }
    },

    /*
     * نفحص الصوت في أكثر من وقت
     * بعد join لأن المشكلة تظهر
     * خصوصاً على الجوال.
     */
    scheduleAudioDiagnostics() {
      const delays = [
        100,
        500,
        1500,
        3000
      ];

      delays.forEach(
        delay => {
          const timer =
            setTimeout(
              () => {
                this.checkLocalAudioState(
                  `join-${delay}ms`
                );
              },
              delay
            );

          this.audioDiagnosticTimers.push(
            timer
          );
        }
      );
    },

    /*
     * ===============================
     * UI
     * ===============================
     */

    handleExpandUserList() {
      this.showExpandUserList =
        !this.showExpandUserList;
    },

    /*
     * ===============================
     * LOCAL VIDEO READY
     * ===============================
     */

    handleVideoReady(
      localVideo,
      info
    ) {
      console.log(
        "[Agora] LOCAL VIDEO READY",
        info
      );

      this.localDirective =
        localVideo;

      this.playLocalVideoOnTopBanner();
    },

    /*
     * ===============================
     * SCREEN
     * ===============================
     */

    handleScreenVideoReady(
      screenVideo
    ) {
      this.youAreShareScreening =
        true;

      this.localScreenDirective =
        screenVideo;
    },

    handleVideoClose() {
      this.localDirective =
        null;
    },

    handleScreenVideoClose() {
      this.youAreShareScreening =
        false;

      this.localScreenDirective =
        null;
    },

    handleScreenVideoFailed() {
      this.handleScreenVideoClose();

      this.openScreenSharing =
        false;
    },

    /*
     * ===============================
     * REMOTE VIDEO
     * ===============================
     */

    handleRemoteVideoReady(
      remoteUserList
    ) {
      this.remoteDirectiveList =
        remoteUserList;
    },

    /*
     * ===============================
     * LOCAL AUDIO TRACK CREATED
     * ===============================
     */

    handleAudioTrackCreated() {
      console.log(
        "[Agora] LOCAL AUDIO TRACK CREATED"
      );

      /*
       * نفحص الـ track مباشرة.
       */
      this.$nextTick(() => {
        this.checkLocalAudioState(
          "track-created"
        );
      });

      /*
       * لا ننشئ أكثر من RAF loop.
       */
      if (
        this.localAudioAnimationId
      ) {
        cancelAnimationFrame(
          this.localAudioAnimationId
        );

        this.localAudioAnimationId =
          null;
      }

      const callback = () => {
        try {
          const audioSender =
            this.$refs.audioSender;

          if (!audioSender) {
            return;
          }

          const track =
            audioSender.getTrack();

          if (
            track &&
            track.getVolumeLevel
          ) {
            this.localVolumeLevel =
              track.getVolumeLevel();
          } else {
            this.localVolumeLevel =
              0;
          }
        } catch (error) {
          console.error(
            "[Agora] LOCAL VOLUME ERROR:",
            error
          );

          this.localVolumeLevel =
            0;
        }

        this.localAudioAnimationId =
          requestAnimationFrame(
            callback
          );
      };

      this.localAudioAnimationId =
        requestAnimationFrame(
          callback
        );
    },

    /*
     * ===============================
     * REMOTE VOLUME
     * ===============================
     */

    handleGetRemoteVolumeLevelList() {
      /*
       * مهم:
       * لا ننشئ loop جديد في كل
       * user-published.
       */
      if (
        this.remoteVolumeAnimationId
      ) {
        return;
      }

      const callback = () => {
        try {
          const audioReceiver =
            this.$refs.audioReceiver;

          this.remoteVolumeLevelList =
            audioReceiver
              ? audioReceiver.getVolumeLevel() ||
                []
              : [];
        } catch (error) {
          this.remoteVolumeLevelList =
            [];
        }

        this.remoteVolumeAnimationId =
          requestAnimationFrame(
            callback
          );
      };

      this.remoteVolumeAnimationId =
        requestAnimationFrame(
          callback
        );
    },

    /*
     * ===============================
     * REMOTE MUTE STATUS
     * ===============================
     */

    handleCheckRemoteUserAudioMuteStatus() {
      /*
       * لا ننشئ RAF loop لكل user.
       */
      if (
        this.remoteMuteAnimationId
      ) {
        return;
      }

      const callback = () => {
        try {
          const audioReceiver =
            this.$refs.audioReceiver;

          this.remoteMuteStatus =
            audioReceiver
              ? audioReceiver.getUserMuteStatus() ||
                []
              : [];
        } catch (error) {
          this.remoteMuteStatus =
            [];
        }

        this.remoteMuteAnimationId =
          requestAnimationFrame(
            callback
          );
      };

      this.remoteMuteAnimationId =
        requestAnimationFrame(
          callback
        );
    },

    /*
     * ===============================
     * STOP MONITORING
     * ===============================
     */

    stopMonitoring() {
      if (
        this.localAudioAnimationId
      ) {
        cancelAnimationFrame(
          this.localAudioAnimationId
        );

        this.localAudioAnimationId =
          null;
      }

      if (
        this.remoteVolumeAnimationId
      ) {
        cancelAnimationFrame(
          this.remoteVolumeAnimationId
        );

        this.remoteVolumeAnimationId =
          null;
      }

      if (
        this.remoteMuteAnimationId
      ) {
        cancelAnimationFrame(
          this.remoteMuteAnimationId
        );

        this.remoteMuteAnimationId =
          null;
      }
    },

    /*
     * ===============================
     * PIN USER
     * ===============================
     */

    handlePinUser(uid) {
      if (
        this.pined &&
        this.pinedUid === uid
      ) {
        this.pined = false;

        this.pinedUid = null;
      } else {
        this.pinedUid = uid;

        this.pined = true;
      }
    },

    /*
     * ===============================
     * SCREEN SHARE
     * ===============================
     */

    handleShareScreen() {
      if (
        !this.youAreShareScreening
      ) {
        if (
          this.otherIsShareScreening
        ) {
          this.$message.warning(
            "شخص اخر يقوم بالمشاركة، وسوف تقوم بالمشاركة بدلة"
          );
        }
      } else {
        this.$message(
          "سوف تقوم بإنهاء مشاركة الشاشة."
        );
      }

      this.openScreenSharing =
        !this.openScreenSharing;
    },

    /*
     * ===============================
     * STREAM FALLBACK
     * ===============================
     */

    handleStreamFallback(
      uid,
      type
    ) {
      const list =
        this.streamFallbackList;

      console.log(
        "[Agora] STREAM FALLBACK",
        {
          uid,
          type
        }
      );

      if (
        type === "recover"
      ) {
        this.streamFallbackList =
          list.filter(
            e => e !== uid
          );
      } else if (
        type === "fallback"
      ) {
        this.streamFallbackList = [
          ...new Set([
            ...list,
            uid
          ])
        ];
      }
    }
  }
};
</script>

<style lang="stylus">
video.agora_video_player
  object-fit: contain !important
</style>

<style
  scoped
  lang="stylus"
>
@import "../styles/meet/index.styl"
</style>
